<template>
  <div>
    <div
      class="footer-container"
      :class="{
        'footer-container-tab': isFromTab,
        'footer-android-big': isAndroid && !isFromTab,
      }"
    >
      <div class="btn-container">
        <div class="bubble">
          <Bubble :bubbleContent="bubbleContent" />
        </div>
        <rich-button @click="handleGoBuy">
          <div class="price">
            <div class="price-box" :class="btnTextLength > 25 && 'smallFont'">
              {{ btnText }}
              <span v-if="delPrice" class="del">{{ delPrice }}</span>
            </div>
          </div>
        </rich-button>
      </div>
    </div>
    <integrated-pay
      v-model="isShowIntegratedPayPopup"
      :membership="membership"
      :btnText="btnText"
      :delPrice="delPrice"
      :payBtnLoading="payBtnLoading"
      @goBuy="handleBuy"
    />
    <member-fail-dialog
      v-model="isShowPayFailedDialog"
      :rules="payFailedReason"
      :title="$t('FoodC_register_cCpr_KUUG')"
      @closeDialog="closePayFailedDialog"
    />
    <LoadingMask v-if="requestLoading" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  MODULE_TYPE,
  SCENARIO_CODE,
  PAY_STATUS,
  SALE_CHANNEL,
  SUCCESS_TYPE,
} from '@/page/member/common/enumsUtil.js'
import Bubble from './bubble.vue'
import IntegratedPay from '@/page/member/components-v2/integrated-pay.vue'
import {
  getCheckBuyMember,
  getBenefitsCreateV2Fulfillment,
  getFintechParams,
  sendMembershipStoreCouponByShopID,
  memberBuyFree,
} from '@/api/member/index.js'
import LoadingMask from '@/components/loading/loading-mask.vue'
import { doPayV2 } from '@/common/js/bridge.js'
import memberFailDialog from './member-fail-dialog.vue'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'SubscribeFooter',
  components: {
    Bubble,
    IntegratedPay,
    LoadingMask,
    memberFailDialog,
  },
  mixins: [mixin],
  inject: ['initCodeData'],
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowIntegratedPayPopup: false,
      requestLoading: false,
      payBtnLoading: false,
      isShowPayFailedDialog: false,
      payFailedReason: [
        {
          content: [this.$t('FoodC_register_qELy_skhp')],
        },
      ],
    }
  },
  computed: {
    ...mapState(['globalParams']),
    isCanSubscribe() {
      return this.membership?.canSubscribe
    },
    bubbleContent() {
      return this.membership?.bubbleContent
    },
    priceText() {
      return this.membership?.priceSplit && this.membership?.priceSplit?.display
    },
    btnText() {
      if (this.isCanSubscribe) {
        return (
          this.$t('FoodC_subscription_YJLt_vjMk', {
            didipackbrand: this.brandName,
          }) +
          ' ' +
          this.priceText
        )
      }
      return this.$t('FoodC_C_Only_money_ZEKz', { money: this.priceText })
    },
    btnTextLength() {
      return this.btnText?.length || 0
    },
    delPrice() {
      if (this.membership?.displayPrice > 0) {
        return this.membership?.displayPriceSplit?.display
      } else {
        return false
      }
    },
    getShopID() {
      return this.params?.shopID || ''
    },
    getBizId() {
      // 在ImmersionHeader组件内进行过一次获取公参的操作，所以这里直接使用了
      return this.$store?.state?.globalParams?.data?.bizId
    },
  },
  methods: {
    async handleGoBuy(val) {
      this.membershipLandingCkFn(MODULE_TYPE.BUY_BUTTON)
      this.isShowIntegratedPayPopup = true
    },
    async handleBuy(val) {
      const productId = this.membership?.saleID
      const price = this.membership?.price
      const canSubscribe = this.isCanSubscribe
      this.payBtnLoading = true
      if (price * 1 === 0) {
        // 只有在0元购的时候获取是否重复购买
        const res = await getCheckBuyMember()
        this.isCheckBuyMember = res?.data?.canPurchase
        // 判断是不是有锁定的会员，只有当canPurchase=false，才刷新页面
        if (this.isCheckBuyMember === false) {
          this.closePayDialogAndLoading()
          this.requestLoading = true
          await this.initCodeData()
          this.requestLoading = false
          return
        }
        const channelID = val?.channelID * 1
        const cardIndex = val?.cardIndex * 1 || 0
        await this.zeroPayment(channelID, cardIndex)
        this.closePayDialogAndLoading()
        return
      }
      const res = await getBenefitsCreateV2Fulfillment({
        productId,
        price,
        canSubscribe,
        scenarioCode: SCENARIO_CODE,
      })
      if (res?.errno === 0) {
        const res1 = await getFintechParams({ renewPrice: 0 })
        if (res1.errno === 0) {
          const resource_id = res1?.data?.resource_id
          // 调用金融的bridge
          const out_trade_id = res?.data?.transId
          const { cityId, clientType, dataType, locationType, osType, osVersion, appId } =
            this.globalParams?.data || {}

          console.log('🚀 ~ doPayV2 start')
          // 客户端要求传string
          doPayV2(
            {
              bizDeviceInfo: JSON.stringify({
                osType: osType + '',
                osVersion: osVersion + '',
                dataType: dataType + '',
                clientType: clientType + '',
                locationType: locationType + '',
                cityId: cityId + '',
              }),
              outTradeId: out_trade_id + '',
              useSodaRandomVerify: true,
              productId: this.getBizId + '',
              appId: appId + '',
              selectedItems: [
                {
                  channelId: val?.channelID + '',
                  extraInfo: { cardIndex: val?.cardIndex + '' },
                },
              ],
              resourceId: resource_id + '',
            },
            async res => {
              console.log('🚀 ~ doPayV2 end', res)
              this.closePayDialogAndLoading()
              if (res?.data?.payStatus === PAY_STATUS.SUCCESS) {
                // 刷新当前页面
                this.requestLoading = true

                await this.initCodeData()
                console.log('doPayV2 initCodeData')

                this.requestLoading = false
                this.openPaySuccessDialog()
                this.sendMembershipStoreCouponByShopIDApi()
              } else {
                // 展示失败原因的弹窗
                this.isShowPayFailedDialog = true
              }
            },
          )
        } else {
          this.payBtnLoading = false
          this.createErrorToast(res1.errmsg || '')
          this.initCodeData()
        }
      } else {
        this.payBtnLoading = false
        this.createErrorToast(res.errmsg || '')
        this.initCodeData()
      }
    },
    closePayDialogAndLoading() {
      this.payBtnLoading = false
      this.isShowIntegratedPayPopup = false
    },
    openPaySuccessDialog() {
      const paySuccessDialogData = {
        date: this.membership?.renewDate,
        price: this.membership?.renewPriceSplit?.display,
      }
      this.$emit('onSuccess', {
        dialogData: paySuccessDialogData,
        type: SUCCESS_TYPE.buy,
      })
    },
    // 根据商家ID发送会员商家券
    sendMembershipStoreCouponByShopIDApi() {
      if (this.isFromShop && this.getShopID) {
        sendMembershipStoreCouponByShopID({
          shopID: this.getShopID,
        })
      }
    },
    closePayFailedDialog() {
      this.isShowIntegratedPayPopup = true
      this.isShowPayFailedDialog = false
    },
    // 零元支付的逻辑
    async zeroPayment(channelID, cardIndex) {
      this.requestLoading = true
      const data = await memberBuyFree({
        saleId: this.membership?.saleID,
        saleChannel: SALE_CHANNEL,
        isSubscribe: this.membership?.canSubscribe ? 1 : 0,
        channelID,
        cardIndex,
      })
      this.requestLoading = false
      if (data?.errno === 0) {
        // 重新请求数据
        this.requestLoading = true
        await this.initCodeData()
        this.requestLoading = false
        // 显示支付成功的弹窗
        this.openPaySuccessDialog()
        this.sendMembershipStoreCouponByShopIDApi()
      } else {
        this.createErrorToast(data?.errmsg || '')
      }
    },
    createErrorToast(errmsg = '', defaultMsg = this.gettext('网络繁忙，请稍后再试')) {
      const errorToast = this.$createToast({
        txt: errmsg || defaultMsg,
        time: 2000,
        mask: false,
        type: 'error',
      })
      errorToast.show()
    },
  },
}
</script>

<style lang="scss" scoped>
.footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 100%;
  background: #ffffff;
  padding: 16px 24px 71px 24px;
  box-sizing: border-box;
}
.footer-android-big {
  padding-bottom: 40px;
}
.footer-container-tab {
  padding: 16px 24px;
  .btn-container {
    .rich-btn {
      height: 104px;
      border-radius: 32px;
      font-family: DiDiSans-Pro-ExtraBold;
      font-size: 40px;
      color: #fff;
      font-weight: normal;
      background: #ff5f14;
    }
  }
}
.btn-container {
  position: relative;
  .rich-btn {
    height: 120px;
    border-radius: 40px;
    font-family: DiDiSans-Pro-ExtraBold;
    font-weight: normal;
    background: #ff5f14;
  }
}
.bubble {
  position: absolute;
  right: 0;
  top: -20px;
}
.price-box {
  font-family: DiDiSans-Pro-ExtraBold;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: normal;
  &.smallFont {
    font-size: 28px;
    span {
      font-size: 24px;
    }
  }
  span {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 36px;
    text-decoration: line-through;
  }
}
</style>
